// Test players are used to fill tournaments with dummy teams. Everywhere: names starting with "z_".
// Padel Eagle additionally uses placeholder names containing "player" (Player_1, player_2, ...).
export function isTestPlayerName(name: string | undefined | null, orgSlug?: string | null): boolean {
  const n = (name || "").trim();
  if (/^z_/i.test(n)) return true;
  return orgSlug === "padel-eagle" && /player/i.test(n);
}

export function testPlayerHint(orgSlug?: string | null): string {
  return orgSlug === "padel-eagle"
    ? 'with "player" in their name (e.g. "Player_1") or "z_" at the start'
    : 'with "z_" (or "Z_") at the start of their name';
}
